"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.describeSubnet = describeSubnet;
exports.describeSubnets = describeSubnets;
var _axios = _interopRequireDefault(require("@jdcloud/jelement-biz/dist/api/axios"));
var _util = require("@jdcloud/jelement-biz/dist/utils/util");
var axios = new _axios.default({
  extra: {
    componentName: 'subnetSelect'
  }
});

// 子网列表获取
function describeSubnets(_ref) {
  var regionId = _ref.regionId,
    filters = _ref.filters,
    cancelToken = _ref.cancelToken,
    _ref$pageNumber = _ref.pageNumber,
    pageNumber = _ref$pageNumber === void 0 ? 1 : _ref$pageNumber;
  return axios({
    url: '/openApi/vpc/describeSubnets',
    method: 'POST',
    params: {
      regionId: regionId
    },
    data: {
      params: {
        pageNumber: pageNumber,
        pageSize: _util.DEFAULT_INFINITE_SCROLL_SIZE,
        filters: filters
      }
    },
    cancelToken: cancelToken
  });
}

// 子网获取
function describeSubnet(_ref2) {
  var regionId = _ref2.regionId,
    subnetId = _ref2.subnetId,
    cancelToken = _ref2.cancelToken;
  return axios({
    url: '/openApi/vpc/describeSubnet',
    method: 'GET',
    params: {
      regionId: regionId,
      params: {
        subnetId: subnetId
      }
    },
    cancelToken: cancelToken
  });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@jdcloud/jelement-biz/dist/api/subnet-select.js
// module id = r7CZ
// module chunks = 19